var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiGrayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_231_15",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 31,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0024 3.00012H3.00235V33.0002H33.0024V3.00012Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_231_15)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5199 10.9693C31.6597 10.9693 32.5836 10.0453 32.5836 8.9055C32.5836 7.76569 31.6597 6.84167 30.5199 6.84167C29.38 6.84167 28.456 7.76569 28.456 8.9055C28.456 10.0453 29.38 10.9693 30.5199 10.9693ZM27.7682 23.212V24.7278H33.0023V23.212L31.6546 22.9521V13.9001L33.0023 13.6402V12.1157H27.7682V13.6402L29.1159 13.9001V22.9521L27.7682 23.212ZM3.00235 24.7278V23.212L3.90658 23.0821L7.93221 12.1157H10.5319L14.5314 23.0821L15.4357 23.212V24.7278H11.1231V23.212L12.0013 23.0561L11.4448 21.3236H6.99318L6.43673 23.0561L7.31488 23.212V24.7278H3.00235ZM7.59311 19.4612H10.8449L9.36681 15.1388L9.24509 14.7577H9.19293L9.0625 15.1648L7.59311 19.4612ZM16.5083 23.212V24.7278H21.7512V23.212L20.3949 22.9521V20.1542H22.5337C23.5017 20.1542 24.3364 19.9897 25.0378 19.6604C25.7391 19.3255 26.2782 18.8578 26.6549 18.2572C27.0317 17.6508 27.2201 16.9463 27.2201 16.1436C27.2201 15.3409 27.0317 14.6393 26.6549 14.0387C26.2782 13.4323 25.7391 12.9617 25.0378 12.6268C24.3364 12.286 23.5017 12.1157 22.5337 12.1157H17.856H16.5083V13.6402L17.856 13.9001V22.9521L16.5083 23.212ZM22.5337 18.2051H20.3949V14.0647H22.5337C23.2409 14.0647 23.7742 14.2639 24.1335 14.6624C24.4987 15.0551 24.6812 15.5546 24.6812 16.1609C24.6812 16.7557 24.4987 17.2466 24.1335 17.6335C23.7742 18.0147 23.2409 18.2051 22.5337 18.2051Z",
    fill: "#FBFDFD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiGrayIcon);
export default __webpack_public_path__ + "static/media/api-gray-icon.0b24e63e5666177a06b432252542cdb0.svg";
export { ForwardRef as ReactComponent };